import React, { Component } from 'react'
import allan from './img/allan.png'
import Navbar from './Navbar'

class Complete extends Component {
  componentDidMount() {
    global.fbq('track', 'CompleteRegistration', {
      value: 25.0,
      currency: 'AUD',
    })
  }
  render() {
    const { match: { url } } = this.props
    return (
      <div>
        <Navbar />
        <div className="container-fluid bg-white">
          <div className="row">
            <div className="col-md-12 heading">
              LLN Robot System free 3-Week trial request submitted.
            </div>
            <div className="col-md-4 col-md-offset-4 lead-text">
              <p className="lead-text padding center">
                Thank you for completing the form.
              </p>
            </div>
          </div>
        </div>
        <div className="row div-height-container paralax">
          <div className="col-md-4 col-md-offset-4 bg-dark">
            <div className="arrow-down" />
            <div className="col-md-12 sub-heading">What happens now?</div>
            <p className="lead-text">
              A trial will be created and the login details and location of the
              trial will be emailed to you within 1 business day.
            </p>
            <p className="lead-text padding">
              If you do not receive the email please contact us at{' '}
              <a
                href="mailto:sales@tlrg.com.au?subject=LLN%20Robot%20System"
                className="link-light">
                sales@tlrg.com.au
              </a>{' '}
              or 1300 221 729.
            </p>
            <a
              href="http://www.tlrg.com.au/"
              className="btn btn-success btn-block padding">
              Go to tlrg.com.au
            </a>
          </div>
        </div>
        <div className="container-fluid bg-white">
          <div className="row">
            <div className="col-md-12 heading">
              What can the LLN Robot System do?
            </div>
            <div className="col-md-4 col-md-offset-4 lead-text">
              <p>
                <strong>
                  The LLN Robot System is more than just a test. Each system
                  comes with:
                </strong>
              </p>
              <ul>
                <li className="li-feature">Non-biased online assessment.</li>
                <li className="li-feature">Multi-level testing.</li>
                <li className="li-feature">
                  Option to invite individuals or groups of learners to take the
                  test.
                </li>
                <li className="li-feature">Learner results database.</li>
                <li className="li-feature">Learner answer report.</li>
                <li className="li-feature">
                  Get the ACSF profile for any current national unit of
                  competency.
                </li>
                <li className="li-feature">
                  Get profiles for the courses that you actually deliver.
                </li>
                <li className="li-feature">
                  Analyse the skills gap for your learners.
                </li>
                <li className="li-feature">Customisable forms.</li>
                <li className="li-feature">Easy user account management.</li>
                <li className="li-feature">System analytics.</li>
                <li className="li-feature">Help at your fingertips.</li>
              </ul>
              <p>
                <strong>
                  Want to find out more? Visit the website for more information :
                </strong>
              </p>
            </div>
            <div className="col-md-4 col-md-offset-4">
              <a
                href="https://tlrg.com.au/pages/lln-robot"
                >
                <button
                  type="button"
                  className="btn btn-primary btn-lg btn-block padding">
                  Visit the website
                </button>
              </a>
            </div>
          </div>
          <div className="col-md-4 col-md-offset-7 div-wrapper hidden-sm hidden-xs">
            <img src={allan} role="presentation" />
          </div>
        </div>
      </div>
    )
  }
}

export default Complete



// WEBPACK FOOTER //
// ./src/Complete.js